import React, { useState, cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Zap, Trophy, Check, Lock, Mail, Shield, RefreshCw } from 'lucide-react';
const packs = [{
  id: 'inicial',
  icon: <Zap className="text-blue-600" data-id="element-140" />,
  title: 'PACK FISICA INICIAL — 7 TOMOS',
  subtitle: 'El más completo',
  features: ['Los 7 Tomos de Física en Acción (1° a 6° año + Feria de Ciencias)', '+ Los 3 Bonos Estratégicos', '+ Acceso a actualizaciones de por vida'],
  oldPrice: '$39.900',
  price: '$19.990 ARS',
  cta: 'Lo quiero ya',
  url: 'https://checkout.guiadigital360.online/cart/43946518052933:1'
}, {
  id: 'vip',
  icon: <Trophy className="text-blue-600" data-id="element-141" />,
  title: 'PACK COMPLETO VIP',
  subtitle: 'Más resuelto, menos corrección',
  isMostPopular: true,
  savings: 'AHORRÁS $9.000 ARS',
  features: ['Contiene todo el Pack inicial + la Bóveda de Evaluación 360', '✅ 40 modelos de solicitudes listas para imprimir (Temas A, B y C)', '✅ Rúbricas maestras para corregir Prácticos, Proyectos y Feria', '✅ Planillas RITE 2026 listas para dirección', '✅ Solucionarios compactos para corregir en la mitad del tiempo', '✅ Grillas de seguimiento de trayectorias (por alumno)'],
  price: '$24.990 ARS',
  cta: 'Sí, quiero el Sistema Total VIP',
  url: 'https://checkout.guiadigital360.online/cart/44779029332037:1'
}, {
  id: 'combo',
  icon: <Trophy className="text-blue-600" data-id="element-142" />,
  title: 'PACK COMPLETO FÍSICA+QUÍMICA JUNTOS',
  subtitle: 'Todo listo y armado',
  savings: 'AHORRÁS $9.000 ARS',
  features: ['Te llevas el combo completo de las dos materias.', 'Todo listo y armado para que no tengas que preocuparte por nada.'],
  oldPrice: '$39.980',
  price: '$32.980 ARS',
  cta: 'Quiero el pack completo',
  url: 'https://checkout.guiadigital360.online/cart/44770181808197:1'
}];
export function Pricing() {
  const [selectedPack, setSelectedPack] = useState('vip');
  const handlePurchase = () => {
    const pack = packs.find(p => p.id === selectedPack);
    if (pack?.url) {
      window.location.href = pack.url;
    }
  };
  return <section id="pricing" className="pt-2 pb-6 md:py-20 px-4 max-w-4xl mx-auto" data-id="element-143">
      <div className="text-center mb-2 md:mb-16" data-id="element-144">
        <h2 className="text-lg md:text-5xl font-black text-slate-900 mb-0.5" data-id="element-145">
          Elegí tu <span className="text-blue-600" data-id="element-146">MegaPack</span> Física en
          Acción:
        </h2>
        <p className="text-slate-600 font-bold text-[9px] md:text-lg" data-id="element-147">
          Todas las opciones incluyen los Bonos Estratégicos
        </p>
      </div>

      <div className="space-y-1 mb-3" data-id="element-148">
        {packs.map(pack => <motion.div key={pack.id} onClick={() => setSelectedPack(pack.id)} className={`cursor-pointer p-3 md:p-8 rounded-xl border-2 transition-all relative overflow-hidden ${selectedPack === pack.id ? 'border-blue-600 bg-white shadow-lg shadow-blue-900/5' : 'border-blue-100 bg-white/50 hover:border-blue-300'}`} data-id="element-149">
            <div className="flex items-start gap-2" data-id="element-150">
              <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 mt-1 ${selectedPack === pack.id ? 'border-blue-600' : 'border-slate-300'}`} data-id="element-151">
                {selectedPack === pack.id && <div className="w-2 h-2 bg-blue-600 rounded-full" data-id="element-152" />}
              </div>

              <div className="flex-1" data-id="element-153">
                <div className="flex items-center justify-between gap-2 mb-0.5" data-id="element-154">
                  <div className="flex items-center gap-1.5" data-id="element-155">
                    {cloneElement(pack.icon as React.ReactElement, {
                  size: 16
                })}
                    <h3 className="font-black text-slate-900 text-xs md:text-xl uppercase leading-none" data-id="element-156">
                      {pack.title}
                    </h3>
                  </div>
                  <div className="flex flex-wrap gap-1" data-id="element-157">
                    {pack.isMostPopular && <span className="bg-blue-600 text-white text-[7px] md:text-[10px] font-black px-1.5 py-0.5 rounded-full uppercase tracking-widest" data-id="element-158">
                        MÁS ELEGIDO
                      </span>}
                  </div>
                </div>

                <div className="flex items-baseline justify-between" data-id="element-159">
                  <p className="text-slate-500 font-bold text-[9px] md:text-sm" data-id="element-160">
                    {pack.subtitle}
                  </p>
                  <div className="flex items-baseline gap-1" data-id="element-161">
                    {pack.oldPrice && <span className="text-slate-400 line-through font-bold text-[9px] md:text-lg" data-id="element-162">
                        {pack.oldPrice}
                      </span>}
                    <span className="text-sm md:text-4xl font-black text-slate-900" data-id="element-163">
                      {pack.price}
                    </span>
                  </div>
                </div>

                {selectedPack === pack.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} className="mt-2 space-y-0.5 border-t border-slate-100 pt-2" data-id="element-164">
                    {pack.features.map((f, i) => <div key={i} className="flex items-start gap-1 text-[9px] md:text-base text-slate-600 font-medium leading-tight" data-id="element-165">
                        <Check size={10} className="text-blue-600 shrink-0 mt-0.5" data-id="element-166" />
                        <span data-id="element-167">{f}</span>
                      </div>)}
                  </motion.div>}
              </div>
            </div>
          </motion.div>)}
      </div>

      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} animate={{
      scale: [1, 1.02, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} onClick={handlePurchase} className="w-full bg-green-500 hover:bg-green-600 text-white font-black text-lg md:text-3xl py-3.5 rounded-xl shadow-[0_0_20px_rgba(34,197,94,0.3)] mb-2 uppercase tracking-tight btn-neon" data-id="element-168">
        {packs.find(p => p.id === selectedPack)?.cta} →
      </motion.button>

      <div className="flex flex-col items-center mb-3 px-4" data-id="element-169">
        <p className="text-slate-600 font-bold md:text-sm text-center mb-1.5 text-[12px]" data-id="element-170">
          ¿Tuviste problemas para pagar con Mercado Pago o preferís
          transferencia?
        </p>
        <motion.a href="https://wa.me/5492966244076?text=Hola,%20quiero%20comprar%20el%20producto%20pero%20tuve%20problemas%20con%20Mercado%20Pago%20o%20prefiero%20pagar%20por%20transferencia.%20%C2%BFMe%20ayud%C3%A1s%20a%20finalizar%20la%20compra?" target="_blank" rel="noopener noreferrer" animate={{
        x: [-1, 1, -1]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="inline-flex bg-[#25D366] hover:bg-[#20ba5a] text-white font-black md:text-sm py-2 px-5 rounded-lg transition-colors uppercase tracking-wide shadow-sm text-[14px] items-start justify-start" data-id="element-171">
          ESCRIBINOS POR WHATSAPP Y TE AYUDAMOS
        </motion.a>
      </div>

      <p className="text-center text-slate-400 text-[8px] md:text-xs font-bold uppercase tracking-widest mb-6" data-id="element-172">
        La opción más elegida por docentes que enseñan Física
      </p>

      <div className="text-center mb-4" data-id="element-173">
        <h4 className="text-slate-900 font-black text-sm md:text-2xl uppercase tracking-tighter" data-id="element-174">
          COMPRÁ TRANQUILO/A
        </h4>
      </div>

      <div className="grid grid-cols-4 gap-2 mb-6" data-id="element-175">
        {[{
        icon: <Lock size={14} data-id="element-176" />,
        title: 'Pago Seguro'
      }, {
        icon: <Mail size={14} data-id="element-177" />,
        title: 'Acceso Instantáneo'
      }, {
        icon: <Shield size={14} data-id="element-178" />,
        title: 'Garantía 7 Días'
      }, {
        icon: <RefreshCw size={14} data-id="element-179" />,
        title: 'Actualizaciones'
      }].map((badge, i) => <div key={i} className="bg-white/50 p-2 rounded-xl border border-blue-50 text-center flex flex-col items-center justify-center" data-id="element-180">
            <div className="text-blue-600 mb-1" data-id="element-181">{badge.icon}</div>
            <p className="font-black text-slate-900 text-[7px] leading-tight" data-id="element-182">
              {badge.title}
            </p>
          </div>)}
      </div>

      <div className="bg-white p-4 rounded-2xl border border-blue-100 flex items-center gap-3" data-id="element-183">
        <div className="bg-blue-50 p-2 rounded-lg shrink-0" data-id="element-184">
          <Shield size={20} className="text-blue-600" data-id="element-185" />
        </div>
        <div data-id="element-186">
          <h5 className="text-slate-900 font-black text-[10px] md:text-xl leading-tight" data-id="element-187">
            Garantía de satisfacción 7 días
          </h5>
          <p className="text-slate-500 font-medium text-[9px] md:text-base leading-tight" data-id="element-188">
            Si no te sirve, te devolvemos el 100% de tu dinero.
          </p>
        </div>
      </div>
    </section>;
}